import { resolveSiteConfigFromEnv } from "./restaurant-platform";

export const siteConfig = resolveSiteConfigFromEnv();
